import { render, staticRenderFns } from "./CaixaMensagem.vue?vue&type=template&id=d0ebdb96&"
import script from "./CaixaMensagem.vue?vue&type=script&lang=js&"
export * from "./CaixaMensagem.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/caixaMensagem.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports